import { Component, OnInit, Input, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SecurityService } from '../../security/security.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() buttonSelected: string;
  deviceSmall: boolean = false;
  deviceSize: string;
  loginButtonText: string;
  hasUserLoggedIn: boolean;
  hasMwmUserLoggedIn: boolean = false;

  isMwmRoute: boolean = false;
  isAdmin: boolean = false;
  isKSolveAdmin: boolean = false;
  private routerSubscription: Subscription;
  private loginSubscription: Subscription;
  private mwmLoginSubscription: Subscription;

  constructor(private router: Router, private authSvc: SecurityService) { }

  ngOnInit() {
    // Check login status reactively
    this.loginSubscription = this.authSvc.isLoggedIn$.subscribe(isLoggedIn => {
      this.hasUserLoggedIn = isLoggedIn;
      this.checkKSolveAdminStatus();
      this.updateLoginButtonText();
    });

    this.mwmLoginSubscription = this.authSvc.isMwmLoggedIn$.subscribe(isLoggedIn => {
      this.hasMwmUserLoggedIn = isLoggedIn;
      this.checkAdminStatus();
      this.updateLoginButtonText();
    });

    this.deviceSmall = window.innerWidth < 992;
    this.updateDeviceSize();

    // Detect initial route
    this.checkMwmRoute(this.router.url);


    // Listen to route changes
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkMwmRoute(event.urlAfterRedirects);
      this.updateLoginButtonText();
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  private checkMwmRoute(url: string) {
    this.isMwmRoute = url.includes('math-with-meenu');
  }

  private checkAdminStatus() {
    if (this.hasMwmUserLoggedIn) {
      const user = this.authSvc.getMwmUser();
      this.isAdmin = (user && (user.username === 'mwm-admin' || user.email === 'admin@mwm.com'));
    } else {
      this.isAdmin = false;
    }
  }

  private checkKSolveAdminStatus() {
    if (this.hasUserLoggedIn) {
      const user = localStorage.getItem('User');
      console.log('DEBUG: checkKSolveAdminStatus', { user, hasUserLoggedIn: this.hasUserLoggedIn });
      this.isKSolveAdmin = (user === 'ksolve-admin');
      console.log('DEBUG: isKSolveAdmin', this.isKSolveAdmin);
    } else {
      this.isKSolveAdmin = false;
    }
  }

  onLoginLogout() {
    const loggedIn = this.isMwmRoute ? this.hasMwmUserLoggedIn : this.hasUserLoggedIn;

    if (loggedIn) {
      this.authSvc.logout();
      this.router.navigate([this.isMwmRoute ? '/math-with-meenu' : '/login']);
    } else {
      this.router.navigate([this.isMwmRoute ? '/math-with-meenu/login' : '/login']);
    }
  }

  getMsMathUrl(): string {
    const token = localStorage.getItem('AuthToken');
    // Use environment variable for MWM URL
    return `${environment.booksUrl}?token=${token}`;
  }

  private updateLoginButtonText() {
    const loggedIn = this.isMwmRoute ? this.hasMwmUserLoggedIn : this.hasUserLoggedIn;
    if (loggedIn) {
      this.loginButtonText = "Log Off";
    } else {
      this.loginButtonText = (this.isMwmRoute ? "Login" : "Log In/Register");
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateDeviceSize();
  }

  private updateDeviceSize() {
    this.deviceSmall = window.innerWidth < 992;
  }
}